import React, { useState } from "react";
import Image from "../../components/image";
import ArrowRight from "../../images/icons/right-arrow-dark.inline.svg";
import ArrowRightAlt from "../../images/icons/arrow-right-big-icon.inline.svg";
import ArrowIcon from "../../images/icons/down-arrow-dark.inline.svg";

import { Link } from "../../utils/customLink";
import { stripHtmlTags } from "../../utils/commonFunctions";

const CardHighlightFeatImage = ({
  featuredImage,
  title,
  desc,
  ctaTitle = "",
  url = "",
  sourceUrl = "",
  titleExtraClasses = "",
  readMoreRotate,
  readMoreStatus,
  readMoreButtonClass = ""
}) => {
  const [readMore, setReadMore] = useState(false);
  const linkName = readMore ? "Read less " : "Read more  ";

  const noHtmlDesc = stripHtmlTags(desc || "");

  return (
    <>
      <div className="planet:bg-gray-darker bg-secondary-bg  rounded-md flex flex-col">
        <div className="bh-block-featured-image">
          <Image
            imageClass={"rounded-t-md h-56 w-full object-cover"}
            imageAlt={featuredImage?.altText || ""}
            image={featuredImage}
            sourceUrl={sourceUrl}
          />
        </div>
        <div className="bh-block-content p-4 flex flex-1 flex-col">
          <h3
            className={`py-4 ${titleExtraClasses}`}
            dangerouslySetInnerHTML={{ __html: title }}
          />

          <div
            className={`flex-1 tab-content_html text-black-lighter planet:text-gray-generic ${!readMore && "pb-4"}`}
            dangerouslySetInnerHTML={{
              __html:
                ctaTitle?.length > 0
                  ? ctaTitle
                  : readMore
                    ? desc
                    : `${noHtmlDesc?.length > 180 ? noHtmlDesc?.substring(0, 180) + "..." : desc}`
            }}
          />

          {!ctaTitle && noHtmlDesc?.length > 180 && (
            <div className="flex">
              <button
                className={`text-xs text-left underline text-gray-generic ${readMoreButtonClass}`}
                onClick={() => setReadMore(!readMore)}
              >
                {linkName}
              </button>
              {!readMore && (
                <span className="flex items-center pl-2">
                  <ArrowIcon
                    className={`stroke-black-lighter planet:stroke-gray-lighter planet:group-hover:stroke-black-lighter -rotate-90 group-hover:stroke-white ${readMoreStatus} ${readMoreRotate}`}
                  />
                </span>
              )}
            </div>
          )}

          {url && ctaTitle && (
            <div
              className={
                "relative planet:gvi-border-light my-4 w-full sm:w-3/4 border-inherit planet:bg-transparent"
              }
            >
              <Link
                to={url}
                title={ctaTitle}
                target="_blank"
                rel="noopener noreferrer"
                className={
                  "flex items-center justify-center py-3 px-2 border border-black-lighter planet:border-white rounded-xxxxl planet:rounded-sm text-center text-bold text-mob sm:text-base sm:text-left !text-black-lighter planet:!text-white visited:text-generic-text hover:border-0 hover:bg-black-lighter hover:!text-white planet:hover:bg-white planet:hover:border-0 planet:hover:!text-generic-text group bg-white planet:bg-transparent"
                }
              >
                <span className="pr-2">{ctaTitle}</span>
                <ArrowRight className="stroke-white ml-4 hidden planet:block planet:group-hover:stroke-black-lighter" />
                <ArrowRightAlt className="fill-current ml-4 planet:hidden" />
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CardHighlightFeatImage;
